import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./scss/index.scss";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import { commonMessages } from "@temp/intl";
import { baseUrl } from "../../app/routes";
import NavItem from "./NavItem";
import backImg from "../../images/arrow-back.svg";
import SvgWonder from "images/SvgWonder";

var NavList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavList, _React$PureComponent);

  function NavList() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, NavList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavList)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      displayedItems: _this.props.items,
      parent: null
    }, _this.handleShowSubItems = function (item) {
      _this.setState({
        parent: item,
        displayedItems: item.children
      });
    }, _this.handleGoBack = function () {
      var grandparent = _this.state.parent.parent;

      if (!grandparent) {
        _this.setState({
          parent: null,
          displayedItems: _this.props.items
        });
      } else {
        var newParent = _this.findItemById(grandparent.id);

        _this.setState({
          displayedItems: newParent.children,
          parent: newParent
        });
      }
    }, _temp));
  }

  _createClass(NavList, [{
    key: "findItemById",
    value: function findItemById(id) {
      var match = null;

      function find(item) {
        if (item.id === id) {
          match = item;
          return true;
        }

        return item.children && item.children.some(find);
      }

      this.props.items.some(find);
      return match;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var hideOverlay = this.props.hideOverlay;
      var _this$state = this.state,
          displayedItems = _this$state.displayedItems,
          parent = _this$state.parent;
      return React.createElement("ul", null, parent ? React.createElement("li", {
        className: "side-nav__menu-item side-nav__menu-item-back"
      }, React.createElement("span", {
        onClick: this.handleGoBack
      }, React.createElement(ReactSVG, {
        path: backImg
      }), " ", parent.name)) : React.createElement(React.Fragment, null, React.createElement("li", {
        className: "side-nav__menu-item side-nav__menu-item--parent"
      }, React.createElement(Link, {
        to: baseUrl,
        className: "side-nav__menu-item-logo",
        onClick: hideOverlay
      }, React.createElement(SvgWonder, null)), React.createElement("span", {
        className: "side-nav__menu-item-close",
        onClick: hideOverlay
      }, React.createElement("span", null))), React.createElement("li", {
        className: "side-nav__menu-item"
      }, React.createElement(Link, {
        to: baseUrl,
        className: "side-nav__menu-item-link",
        onClick: hideOverlay
      }, React.createElement(FormattedMessage, commonMessages.home)))), displayedItems.map(function (item) {
        return React.createElement(NavItem, _extends({
          key: item.id,
          hideOverlay: hideOverlay,
          showSubItems: _this2.handleShowSubItems
        }, item));
      }));
    }
  }]);

  return NavList;
}(React.PureComponent);

export default NavList;